import { runDefault, runLayoutDefault, runComponentDefault, runModuleDefault } from "./utils/runner-functions";

import { initVariables, isTouchDevice } from "./utils/variables";
import { initLinkPrefetch } from "./utils/link-prefetch";
import { initScroller } from "./base/scroll";

import gsap from "gsap";

export function init() {
    initGlobalScripts();
    initLayoutScripts();
    initComponentScripts();
    initModuleScripts();
}

function initGlobalScripts() {
    initVariables();
    initScroller();
    initLinkPrefetch();
    runDefault("grid");

    if (!isTouchDevice) {
        runDefault("scroll-anims");
    }
}

function initLayoutScripts() {
    runLayoutDefault("footer");
    runLayoutDefault("header");
    runLayoutDefault("nav");
    runLayoutDefault("mbl-nav");
    runLayoutDefault("video-modal");
    runLayoutDefault("people-modal");
    runLayoutDefault("search-modal");

    setTimeout(() => {
        runLayoutDefault("colour-sections");
    }, 1000);
}

function initComponentScripts() {
    runComponentDefault("accordion", ".accordion");
    runComponentDefault("detail", ".floating-title--reveal");
    runComponentDefault("nav-list", ".nav-list");
    runComponentDefault("select", ".c-select");
    runComponentDefault("header-logo", ".header__logo__inner");

    if (!isTouchDevice) {
        runComponentDefault("btn-hover", ".btn, .link");
        runComponentDefault("spotlight", ".spotlight");
    }
}

function initModuleScripts() {
    runModuleDefault("hero", ".hero");
    runModuleDefault("home-hero", ".home-hero");
    runModuleDefault("detail-image", ".detail-image");
    runModuleDefault("carousel", ".carousel");
    runModuleDefault("strategy", ".strategy");
    runModuleDefault("search-form", ".search-form");
    runModuleDefault("region", ".region");
    runModuleDefault("form-switch", ".form-switch");
    runModuleDefault("listing", ".listing");
    runModuleDefault("checker", ".checker__main");
}
